import { render, staticRenderFns } from "./edition-select.vue?vue&type=template&id=3213cd6a"
import script from "./edition-select.vue?vue&type=script&lang=js"
export * from "./edition-select.vue?vue&type=script&lang=js"
import style0 from "./edition-select.vue?vue&type=style&index=0&id=3213cd6a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports